<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <modal-likes :targetItem="getModalLikesTarget" ref="modalLikes"/>
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_rtfb_on.png" alt="">
                {{$t('rtfbType')}}
            </h1>
            <span class="info-right">
            </span>
          </div>
          <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
          <div class="ibox flex-option">
            <!-- feedback-item -->
            <template>
                <div v-if ="!Object.values(getRtfbsList)[0]" class="">
                  <div class="ibox-title">{{$t('notExistFBRequest')}}</div>
                </div>
                 <div class="ibox-child"  v-for="(feed, index) in getFeeds" :key="feed.id" v-if="Object.values(getRtfbs)[0] && feed.feed && feed.feed.contentText">
                  <div @click="onClickRequest(feed.feed, feed.key)" class="flex-box cursor" v-observe-visibility="visibilityChanged" :accessKey="index">
                    <template v-if="getUserInfoById(feed.feed.userId).isDeleted">
                      <span class="info-userimg">
                        <img v-if="getUserInfoById(feed.feed.userId).userIcon" :src="getUserInfoById(feed.feed.userId).userIcon" alt="image" class="img-circle">
                        <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                      </span>
                    </template>
                    <template v-else>
                      <router-link @click.prevent :to="{ name: 'User', params: { userId: feed.feed.userId }}">
                        <span class="info-userimg">
                          <img v-if="getUserInfoById(feed.feed.userId).userIcon" :src="getUserInfoById(feed.feed.userId).userIcon" alt="image" class="img-circle">
                          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                        </span>
                      </router-link>
                    </template>
                      <div class="comment">
                          <fb-item :detailView="false" :item="feed.feed" :itemId="feed.key" :isDeletedUser="getUserInfoById(feed.feed.userId).isDeleted"/>
                          <div class="child-tools">
                              <span class="info-menu">
                                <a class="info-comment" href="#">
                                  <span class="isExistUnread">
                                    <!-- <img v-if="getFBUnreadCommentKeys(feed.key, feed.feed.comments || {}) > 0" src="static/img/assets/comment_on.png"> -->
                                    <img src="static/img/assets/comment.png">
                                    <!--
                                      <span v-if="getFBUnreadCommentKeys(feed.key) > 0">{{ getFBUnreadCommentKeys(feed.key) | lessThanHundred }}</span>
                                    -->
                                  </span>
                                  <span v-bind:class="{ unread: isUnreadFBCommentsExist(feed.key, feed.feed)}">{{ getCommentsByCommentIdsTargetType(feed.feed.comments || {},'rtfbs').length }}</span>
                                </a>
                                <a class="info-comment">
                                  <img v-if="isLiked(feed.feed)" @click.stop="onClickStarLiked(feed.feed, feed.key)" :src="'static/img/assets/nice_on.png'">
                                  <img v-else @click.stop="onClickStarNotLiked(feed.feed, feed.key)" :src="'static/img/assets/nice_off.png'">
                                  <span class="like-counter" @click.stop="showModalLikes(feed.feed, feed.key)" v-if="feed.feed.likes"><strong v-bind:class="{ unread: isUnreadLikeExist(feed.key, feed.feed.userId, feed.feed.likes) }">{{ feed.feed.likes ? Object.keys(feed.feed.likes).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
                                </a>
                                <!--
                                <a class="info-comment">
                                  <img v-if="isLiked(feed.feed)" @click.stop="onClickStarLiked(feed.feed, feed.key)" :src="'static/img/assets/nice_on.png'">
                                  <img v-else @click.stop="onClickStarNotLiked(feed.feed, feed.key)" :src="'static/img/assets/nice_off.png'">
                                  <span>{{ feed.feed.likes ? Object.keys(feed.feed.likes).length : 0 }}</span>
                                </a>
                              -->
                              </span>
                              <span class="info-right">
                                <fb-drop-down v-if="getUserId == feed.feed.userId" :item="feed.feed" :id="feed.key"/>
                              </span>
                          </div>
                      </div>
                    </div>
                </div>
              </template>
              <!-- /feedback-item -->
          </div>
        </section>
      </article>
      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap">
              <div v-if="this.getTargetFeed" class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">{{$t('rtfbType')}}</span>
                <span class="info-right">
                  <span class="info-time">{{ this.getTargetFeed.createdAt | preparedTime }}</span>
                </span>
              </div>
            <template v-if="this.getTargetFeed && this.getTargetFeed.contentText" id="fb-detail1" class="ibox">
              <div ref="detail" class="ibox-title detail-head cursor">
                <div class="flex-box">
                  <span class="info-userimg">
                    <img v-if="targetUserIcon" :src="targetUserIcon" alt="image" class="img-circle">
                    <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                  </span>
                  <div class="comment">
                    <div class="info-userelement">
                      <a href="#">
                        <span class="info-username">{{ targetUserName }}</span>
                      </a>
                      <span class="info-time">
                        <!-- {{ this.getTargetFeed.createdAt | preparedTime }} -->
                      </span>
                    </div>
                    <span class="comment-text">
                      <read-more :text="this.getTargetFeed.contentText" :targetId="this.getTargetFeedKey" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight" >
                        {{this.getTargetFeed.contentText}}
                      </read-more>
                    </span>
                    <div v-if="getTargetFeed.uploadedFile" class="image-add">
                      <div class="uploaded-images" v-viewer="{
                        button: true,
                        navbar: false,
                        title: false,
                        toolbar: false,
                        tooltip: false,
                        movable: true,
                        zoomable: true,
                        rotatable: true,
                        scalable: false,
                        transition: true,
                        fullscreen: true,
                        keyboard: false }" @click.stop>
                        <img :src="getTargetFeed.uploadedFile">
                      </div>
                    </div>
                    <div class="child-tools">
                      <span class="info-menu">
                        <a class="info-comment" href="#">
                          <img src="static/img/assets/comment.png">
                          <span>{{ getCommentsByCommentIdsTargetType(getTargetFeed.comments || {},'rtfbs').length }}</span>
                        </a>
                        <a class="info-comment">
                          <img v-if="isLiked(getTargetFeed)" @click.stop="onClickStarLiked(getTargetFeed, getTargetFeedKey)" :src="'static/img/assets/nice_on.png'">
                          <img v-else @click.stop="onClickStarNotLiked(getTargetFeed, getTargetFeedKey)" :src="'static/img/assets/nice_off.png'">
                          <span class="like-counter" @click.stop="showModalLikes(getTargetFeed, targetFeedKey)" v-if="getTargetFeed.likes"><strong>{{ getTargetFeed.likes ? Object.keys(getTargetFeed.likes).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
                        </a>
                        <!--
                        <a class="info-comment" @click.stop="onClickStarToggle(getTargetFeed, getTargetFeedKey)">
                          <img :src="'static/img/assets/doLike.png'" :class="{like: !!isLiked(getTargetFeed), 'not-like': !isLiked(getTargetFeed)}">
                        </a>
                        -->
                      </span>
                      <!-- <span class="info-right">
                        <fb-drop-down v-if="getUserId == getTargetFeed.userId" :item="getTargetFeed" :id="getTargetFeedKey"/>
                      </span> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- 公開設定detail -->
              <div class="ibox-child ublic-wrap">
                  <div class="row">
                      <div class="form-group col-sm-12 info-status public-detail-status">
                          <div class="public-detail">
                            <div>
                              <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                              <span v-if="!getTargetFeed.limitedAccess">{{$t('allPeopleStrType')}}</span>
                              <span v-else-if="getTargetFeed.limitedAccess.limitedUsers">{{$t('userBtnTile')}}</span>
                              <span v-else-if="targetLimitedGroups">{{$t('peopleGroupTileType')}}</span>
                              <span v-else-if="targetLimitedOrgs">{{$t('organizationLabelStr')}}</span>
                            </div>
                          </div>
                          <div v-if="getTargetFeed.limitedAccess && getTargetFeed.limitedAccess.limitedUsers" class="public-box">
                            <ul>
                              <li v-for="limited in getTargetLimitedUsers" :key="limited.id" class="public-cell">
                                <span class="public-userimg">
                                  <img v-if="limited.userInfo.userIcon" :src="limited.userInfo.userIcon" alt="image" class="img-circle">
                                  <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                </span>
                                <div class="public-userinfo">
                                  <span class="public-username">{{limited.userInfo.userName}}</span>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div class="public-detail">
                            <div v-if="getTargetFeed.limitedAccess && getTargetFeed.limitedAccess.limitedUsers && targetLimitedGroups">
                              <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                              <span>{{$t('peopleGroupTileType')}}</span>
                            </div>
                          </div>
                          <div v-if="getTargetFeed.limitedAccess && (getTargetFeed.limitedAccess.limitedGroups || getTargetFeed.limitedAccess.limitedGroup)" class="public-detail-group">
                            <ul>
                              <li v-for="lgroup in targetLimitedGroups" :key="lgroup.id" class="public-username">
                                <span class="public-username">{{lgroup.groupName}}</span>
                              </li>
                            </ul>
                          </div>
                          <div class="public-detail">
                            <div v-if="getTargetFeed.limitedAccess && (getTargetFeed.limitedAccess.limitedUsers || targetLimitedGroups)&& targetLimitedOrgs">
                              <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                              <span>{{$t('organizationLabelStr')}}</span>
                            </div>
                          </div>
                          <div v-if="targetLimitedOrgs" class="public-detail-group">
                            <ul>
                              <li v-for="(org, key) in targetLimitedOrgs" :key="org.id" class="public-username">
                                <span class="public-username">{{org.groupName}}</span>
                              </li>
                            </ul>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- /公開設定detail -->
              <div class="ib-sub-content">
                <b-tabs>
                  <b-tab :title="$t('commentLabelTitle')" @click="showCommentForm">
                    <div v-if="!getTargetComments[0]"  class="comment-view ibox-child"><span class="comment-text">{{$t('stillNotCommentStr')}}</span></div>
                    <div v-else class="comment-view">
                      <div v-for="obj in getTargetComments" :key="obj.id" class="ibox-child" v-if="!obj.parentId">
                        <comment-item @set-reply="setParentCommentId" :propComment="obj" :isDetailViewOpen="open"/>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab :title="$t('niceBtnTitle')" @click="showLikes">
                      <div v-if="!this.getTargetFeed.likes" class="comment-view ibox-child"><span class="comment-text">{{$t('stillNotLikesStr')}}</span></div>
                      <div v-else class="comment-view">
                        <div v-for="(value, key) in getTargetFeed.likes" :key="value.id" v-if="getTargetFeed.likes" class="ibox-child">
                          <template v-if="getUserInfoById(key).isDeleted">
                            <span class="search-userimg">
                              <img v-if="getUserInfoById(key).userIcon" :src="getUserInfoById(key).userIcon" alt="image" class="img-circle">
                              <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                            </span>
                            <div class="search-userinfo">
                              <span class="search-username">{{ getUserInfoById(key).userName }}</span>
                              <span class="search-userdept">{{ getUserInfoById(key).dept }}</span>
                            </div>
                          </template>
                          <template v-else>
                            <router-link :to="{ name: 'User', params: { userId: key }}">
                              <div class="cursor">
                                <span class="search-userimg">
                                  <img v-if="getUserInfoById(key).userIcon" :src="getUserInfoById(key).userIcon" alt="image" class="img-circle">
                                  <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                </span>
                                <div class="search-userinfo">
                                  <span class="search-username">{{ getUserInfoById(key).userName }}</span>
                                  <span class="search-userdept">{{ getUserInfoById(key).dept }}</span>
                                </div>
                              </div>
                            </router-link>
                          </template>
                        </div>
                      </div>
                  </b-tab>
                </b-tabs>
              </div>
          </template>
          </div>
        </section>
        <article v-if="isShowCommentForm" class="sub-column-comment sub-column-active">
          <section>
            <comment-form @close-event="open = false" ref="setReply" :parentItem="this.replyParent" :targetId="getTargetFeedKey" :target="'rtfbs'" :userId="getTargetUserId" :targetOwner="getTargetUserId"/>
          </section>
        </article>
      </article>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FbItem from '@/components/Fb/FbItem'
import FbDropDown from '@/components/Fb/FbDropDown'
import CommentItem from '@/components/Comment/CommentItem'
import CommentForm from '@/components/Comment/CommentForm'
import ModalLikes from '@/components/Comment/ModalLikes'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import moment from 'moment'

export default {
  name: 'FbRequestList',
  components: {
    FbItem,
    FbDropDown,
    CommentItem,
    ReadMore,
    CommentForm,
    ModalLikes
  },
  data: function () {
    return {
      tag: 'progress',
      open: false,
      detail: {},
      targetFeed: {},
      targetFeedKey: '',
      targetType: 'rtfbs',
      targetUserId: '',
      targetUserName: '',
      targetUserIcon: '',
      replyParent: {},
      fbCount: 30,
      propShowMore: false,
      propContentHeight: 0,
      isShowCommentForm: true,
      modalTargetFeed: {}
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'FbRequestList'
    },
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('rtfbs/', [
      'getRtfbs',
      'getRtfbsByCurrentId',
      'getIsReadLike'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId',
      'getIsReadComment',
      'getCommentsByCommentIdsTargetType'
    ]),
    ...mapGetters('groups/', [
      'getGroupMembersByIds',
      'getGroupsByIds',
      'getCurrentGroups'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds',
      'getUserInfoById'
    ]),
    getTargetComments () {
      return this.getCommentsByCommentIdsTargetType(this.targetFeed.comments || {}, this.targetType)
    },
    getRtfbsList () {
      // return this.getRtfbsByCurrentId
      const feeds = this.getRtfbsByCurrentId
      let feedsForShow = []
      for (const feedKey in feeds) {
        if (feeds[feedKey].contentText) {
          feedsForShow.push({
            key: feedKey,
            feed: feeds[feedKey]
          })
        }
      }
      return feedsForShow.reverse().slice(0, this.fbCount)
    },
    getFeeds () {
      const feeds = this.getRtfbs
      let feedsForShow = []
      for (let feedKey of Object.keys(feeds)) {
        if (this.canGetFeed(feeds[feedKey], this.getUserId, this.getCurrentGroups)) {
          feedsForShow.push({
            key: feedKey,
            feed: feeds[feedKey]
          })
        }
      }
      return feedsForShow.reverse().slice(0, this.fbCount)
    },
    getTargetFeed: function () {
      // this.targetFeed = this.getRtfbs
      // console.log('this.targetfeed', this.targetFeed)
      // console.log('this.targetfeed key', this.targetFeedKey)
      // console.log('this.targetfeed key object', this.getRtfbs[this.targetFeedKey])
      this.targetFeed = this.getRtfbs[this.targetFeedKey]
      console.log('targetfeed =>', this.targetFeed)
      // return this.getRtfbs[this.targetFeedKey] ? this.getRtfbs[this.targetFeedKey] : {}
      return this.targetFeed
    },
    getTargetFeedKey () {
      console.log(this.targerFeedkey)
      return this.targetFeedKey
    },
    getTargetUserId () {
      return this.targetUserId
    },
    getModalLikesTarget () {
      return this.modalTargetFeed
    },
    getTargetLimitedUsers () {
      return this.getUsersByIds(Object.keys(this.getTargetFeed.limitedAccess.limitedUsers))
    },
    targetLimitedGroups: function () {
      if (this.getTargetFeed.limitedAccess && this.getTargetFeed.limitedAccess.limitedGroups) {
        let groups = this.getGroupsByIds(Object.keys(this.getTargetFeed.limitedAccess.limitedGroups))
        let groupIds = Object.keys(groups).filter(x => !groups[x].isOrganization)
        return groupIds.length > 0 ? this.getGroupsByIds(groupIds) : null
      }
      return null
    },
    targetLimitedOrgs: function () {
      if (this.getTargetFeed.limitedAccess && this.getTargetFeed.limitedAccess.limitedGroups) {
        let groups = this.getGroupsByIds(Object.keys(this.getTargetFeed.limitedAccess.limitedGroups))
        let orgIds = Object.keys(groups).filter(x => groups[x].isOrganization)
        return orgIds.length > 0 ? this.getGroupsByIds(orgIds) : null
      }
      return null
    }
  },
  methods: {
    ...mapActions({
      setReadTime: 'setReadTime'
    }),
    ...mapActions('rtfbs/', {
      // VuexFireからのActionを読み込み
      setLikes: 'SET_LIKES',
      removeLikes: 'REMOVE_LIKES'
    }),
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    },
    visibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.fbCount - 1) {
        this.fbCount += 30
        this.$forceUpdate()
      }
    },
    onClickRequest: function (feed, key) {
      console.log('onclick true', key)
      this.targetFeedKey = key
      this.targetUserId = feed.userId
      this.targetUserName = this.getUserInfoById(feed.userId).userName
      this.targetUserIcon = this.getUserInfoById(feed.userId).userIcon
      if (!this.open) {
        this.open = true
      }
      if (this.isShowCommentForm) {
        for (let commentId in feed.comments) {
          if (!this.getIsReadComment('rtfbs', feed.userId, key, commentId)) {
            this.setReadTime({
              itemType: 'comments',
              targetType: 'rtfbs',
              targetOwner: feed.userId,
              targetId: key,
              itemId: commentId,
              readTime: new Date().getTime()
            })
          }
        }
      } else {
        for (let likeOwner in feed.likes) {
          if (!this.getIsReadLike(feed.userId, key, likeOwner)) {
            this.setReadTime({
              itemType: 'likes',
              targetType: 'rtfbs',
              targetOwner: feed.userId,
              targetId: key,
              likeOwner: likeOwner,
              readTime: new Date().getTime()
            })
          }
        }
      }
    },
    onClickStarNotLiked: function (feed, key) {
      this.setLikes({
        key: key,
        userId: this.getUserId
      })
    },
    onClickStarLiked: function (feed, key) {
      this.removeLikes({
        key: key,
        userId: this.getUserId
      })
    },
    onClickStarToggle: function (feed, key) {
      if (this.isLiked(feed)) {
        this.onClickStarLiked(feed, key)
      } else {
        this.onClickStarNotLiked(feed, key)
      }
    },
    showModalLikes (feed, key) {
      for (let likeOwner in feed.likes) {
        if (!this.getIsReadLike(feed.userId, key, likeOwner)) {
          this.setReadTime({
            itemType: 'likes',
            targetType: 'rtfbs',
            targetOwner: feed.userId,
            targetId: key,
            likeOwner: likeOwner,
            readTime: new Date().getTime()
          })
        }
      }
      this.modalTargetFeed = feed
      this.$refs.modalLikes.showModal()
    },
    /*
    getFBUnreadCommentKeys (itemId) {
      let unreadCommentKeys = []
      const rtfbComments = this.getRtfbs[itemId].comments
      for (const commentKey in rtfbComments) {
        if (!this.getIsReadComment(commentKey) && !rtfbComments[commentKey].isDelete) {
          unreadCommentKeys.push(commentKey)
        }
      }
      return unreadCommentKeys
    },
    */
    isUnreadFBCommentsExist (itemId, feed) {
      for (let commentId in feed.comments) {
        if (!this.getIsReadComment('rtfbs', feed.userId, itemId, commentId)) {
          return true
        }
      }
      return false
    },
    isUnreadLikeExist (rtfbsKey, rtfbsOwnerId, likeOwners) {
      for (let likeOwner in likeOwners) {
        if (!this.getIsReadLike(rtfbsOwnerId, rtfbsKey, likeOwner)) {
          return true
        }
      }
      return false
    },
    isLiked: function (feed) {
      if (!feed.likes) {
        return false
      } else {
        return Object.keys(feed.likes).filter(x => x === this.getUserId).length !== 0
      }
    },
    setParentCommentId: function (value) {
      this.replyParent = value
      console.log('setParentCommentId = ', this.replyParent)
      this.$refs.setReply.setContentTextByParent(value.item, value.id)
    },
    showCommentForm () {
      for (let commentId in this.targetFeed.comments) {
        if (!this.getIsReadComment('rtfbs', this.targetUserId, this.targetFeedKey, commentId)) {
          this.setReadTime({
            itemType: 'comments',
            targetType: 'rtfbs',
            targetOwner: this.targetUserId,
            targetId: this.targetFeedKey,
            itemId: commentId,
            readTime: new Date().getTime()
          })
        }
      }
      this.isShowCommentForm = true
    },
    showLikes () {
      for (let likeOwner in this.targetFeed.likes) {
        if (!this.getIsReadLike(this.targetUserId, this.targetFeedKey, likeOwner)) {
          this.setReadTime({
            itemType: 'likes',
            targetType: 'rtfbs',
            targetOwner: this.targetUserId,
            targetId: this.targetFeedKey,
            likeOwner: likeOwner,
            readTime: new Date().getTime()
          })
        }
      }
      this.isShowCommentForm = false
    },
    canGetFeed (feed, userId, groups) {
      switch (true) {
        case feed.userId === userId:
        case !feed.limitedAccess:
        case feed.limitedAccess.limitedUsers && Object.keys(feed.limitedAccess.limitedUsers).includes(userId):
        case feed.limitedAccess.limitedGroups && Object.keys(groups).filter(x => Object.keys(feed.limitedAccess.limitedGroups).includes(x)).length > 0:
        case feed.limitedAccess.limitedGroup && Object.keys(groups).filter(x => x === feed.limitedAccess.limitedGroup).length > 0:
          return true
        default:
          return false
      }
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    },
    lessThanHundred: function (unreadCount) {
      return unreadCount > 99 ? 99 : unreadCount
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column;
  }
  /* .ibox-child:first-of-type {
    border-top: solid 1px #e7eaec;
  }
  .ibox-child:last-of-type {
    border-top: 0px;
  } */
</style>



// WEBPACK FOOTER //
// src/views/fb/FbRequestList.vue